import { Action } from 'redux';
import { Epic } from 'redux-observable';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import { concat as concat$ } from 'rxjs/observable/concat';
import { from as from$ } from 'rxjs/observable/from';
import {
    ACTION_FORMTEMPLATEFILETYPE_LOAD,
    ACTION_FORMTEMPLATEFILETYPE_LOAD_BY_ID,

    ACTION_FORMTEMPLATEFILETYPE_SAVE,

    ACTION_FORMTEMPLATEFILETYPE_CREATE,

    IFormTemplateFileTypeLoadAction,
    IFormTemplateFileTypeLoadByIdAction,
    IFormTemplateFileTypeLoadFailureAction,
    IFormTemplateFileTypeLoadSuccessAction,

    IFormTemplateFileTypeSaveAction,
    IFormTemplateFileTypeSaveSuccessAction,
    IFormTemplateFileTypeSaveFailureAction,

    IFormTemplateFileTypeCreateAction,
    IFormTemplateFileTypeCreateSuccessAction,
    IFormTemplateFileTypeCreateFailureAction,

    LoadSuccess,
    LoadFailure,

    SaveSuccess,
    SaveFailure,

    CreateSuccess,
    CreateFailure,

} from "../actions/formTemplateFileTypes";
import { formTemplateFileTypeApi } from "../services/formTemplateFileType";

export const
    getFormTemplateFileTypesEpic = (action$): Observable<IFormTemplateFileTypeLoadSuccessAction | IFormTemplateFileTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_LOAD)
            .mergeMap((action: IFormTemplateFileTypeLoadAction) => {
                return formTemplateFileTypeApi
                    .getFormTemplateFileTypes()
                    .map(response =>
                        LoadSuccess(response.formTemplateFileTypes, undefined, undefined, [], [], response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getFormTemplateFileTypeByIdEpic = (action$): Observable<IFormTemplateFileTypeLoadSuccessAction | IFormTemplateFileTypeLoadFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_LOAD_BY_ID)
            .mergeMap((action: IFormTemplateFileTypeLoadByIdAction) => {
                return formTemplateFileTypeApi
                    .getFormTemplateFileTypeById(action.id)
                    .map(response =>
                        LoadSuccess(response.formTemplateFileType, response.formState, response.formProperties, response.formRoles, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setFormTemplateFileTypeEpic = (action$): Observable<IFormTemplateFileTypeSaveSuccessAction | IFormTemplateFileTypeSaveFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_SAVE)
            .mergeMap((action: IFormTemplateFileTypeSaveAction) => {
                return formTemplateFileTypeApi
                    .setFormTemplateFileType(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.formTemplateFileType, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createFormTemplateFileTypeEpic = (action$): Observable<IFormTemplateFileTypeCreateSuccessAction | IFormTemplateFileTypeCreateFailureAction> => {
        return action$
            .ofType(ACTION_FORMTEMPLATEFILETYPE_CREATE)
            .mergeMap((action: IFormTemplateFileTypeCreateAction) => {
                return formTemplateFileTypeApi
                    .createFormTemplateFileType()
                    .map(response =>
                        CreateSuccess(
                            response.formTemplateFileType,
                            response.formState,
                            response.formProperties,
                            response.formRoles,
                            response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    }



